export default __webpack_public_path__ + "static/iconography-image-f-4a841e7a068c10b5666932b21764bd97.png";